interface GeoJsGeoResponse {
  ip: string;
  country: string;
  country_code: string;
  city: string;
  region: string;
  latitude: string;
  longitude: string;
  accuracy: number;
  timezone: string;
}

export interface GeolocationData {
  countryCode: string | null;
  region: string | null;
}

class GeoJsService {
  private readonly baseUrl = 'https://get.geojs.io';

  getGeolocationData(): {
    promise: Promise<GeolocationData>;
    cancel: () => void;
  } {
    const controller = new AbortController();

    const promise = fetch(`${this.baseUrl}/v1/ip/geo.json`, {
      signal: controller.signal,
    })
      .then(r => {
        if (!r.ok) {
          throw new Error(`GeoJS request failed with status ${r.status}`);
        }

        return r.json() as Promise<GeoJsGeoResponse>;
      })
      .then(data => ({
        countryCode: data.country_code ?? null,
        region: data.region ?? null,
      }));

    return {
      promise,
      cancel: () => controller.abort(),
    };
  }
}

export const geoJsService = new GeoJsService();
